module.exports = __webpack_public_path__ + "static/ADSA-Gold-2021-16fd044a10f7b8c0c35dc929e527847a.png";